import { DocumentItem } from "../model/autogen/DocumentItem";

export function reOrderDocumentItems(documents: DocumentItem[], newOrder: { id: string }[]): DocumentItem[] {
    const newOrderedItems = [];
    let order = 0;
    for (const it of newOrder) {
        const doc = documents.filter(i => i.guid == it.id)[0];
        if (doc) {
            doc.order = order;
            newOrderedItems.push(doc);
            order++;
        }
    }
    return newOrderedItems;
}

export function sortDocumentItems(documents: DocumentItem[]): DocumentItem[] {
    return documents.sort((a, b) => {
        if (a.order < b.order)
            return -1;
        else if (a.order > b.order)
            return 1;
        else
            return 0;
    });
}


// WEBPACK FOOTER //
// ./src/utils/document-order.ts